import { Redirect } from "react-router"
import { useSelector } from 'react-redux'
import useIsLogged from "utils/useIsLogged"
import { arrayPartialMatch } from "utils/arrayUtils"

const AuthGuard = (props) => {
  const { path } = props
  const userPermissions = useSelector(state => state?.auth?.userData?.role?.permissions)
  const isLogged = useIsLogged()

  // Helper function to normalize paths by removing trailing slashes
  const normalizePath = (pathStr) => {
    return pathStr === '/' ? pathStr : pathStr.replace(/\/+$/, '')
  }

  // Helper function to check both prefixed and non-prefixed paths
  const matchesPath = (targetPath) => {
    const normalizedCurrentPath = normalizePath(path)
    const normalizedTargetPath = normalizePath(targetPath)
    
    // Routes that expect path parameters should use startsWith matching
    const routesWithParams = [
      '/shop/returns/details',
      '/shop/orders/details',
      '/shop/invoice/details',
      '/shop/offers/details',
      '/shop/lists/details',
      '/shop/tutorial',
      '/shop/job'
    ]
    
    const isRouteWithParams = routesWithParams.some(route => normalizedTargetPath === route)
    
    if (normalizedTargetPath.startsWith('/shop/')) {
      const nonPrefixed = normalizePath(normalizedTargetPath.replace('/shop', ''))
      
      if (isRouteWithParams) {
        // For routes with params, check if current path starts with target path
        return normalizedCurrentPath.startsWith(normalizedTargetPath) ||
               normalizedCurrentPath.startsWith(nonPrefixed)
      } else {
        // For exact routes, use exact matching
        return normalizedCurrentPath === normalizedTargetPath ||
               normalizedCurrentPath === nonPrefixed
      }
    }
    
    // For non-shop routes, check if it's a route with params
    if (isRouteWithParams && normalizedCurrentPath.startsWith(normalizedTargetPath)) {
      return true
    }
    
    return normalizedCurrentPath === normalizedTargetPath
  }

  // Helper function to check if path starts with any of the given prefixes
  const matchesAnyPath = (targetPaths) => {
    return targetPaths.some(targetPath => matchesPath(targetPath))
  }

  if(path === "/admin") {
    if (!isLogged || !arrayPartialMatch(userPermissions,
        ["WEBSHOP_ADMIN", "WEBSHOP_HR_ADMIN", "WEBSHOP_MARKETING_ADMIN"]))
        //ADMIN_WRITE WEBSHOP_ADMIN ADMIN_READ ADMIN_DELETE
      return <Redirect to="/login" />
  }

  if(matchesPath("/shop/dashboard")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/cart")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/invoices")) {
    if(!isLogged || !userPermissions?.includes?.("CLIENT_INVOICE_READ") )
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/invoice/details")) {
    if(!isLogged || !userPermissions?.includes?.("CLIENT_INVOICE_READ") )
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/orders")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/orders/details")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/returns")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesAnyPath(["/shop/returns/details"])) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/offers")) {
    if(!isLogged || !userPermissions?.includes?.("CUSTOMER_OFFER_READ"))
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/offers/details")) {
    if(!isLogged || !userPermissions?.includes?.("CUSTOMER_OFFER_READ"))
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/lists")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/lists/details")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/careers")) {//TODO ASK QA TEAM IF THIS IS OK
    if(isLogged)
    return <Redirect to="/404" />
  }

  if(matchesAnyPath(["/shop/job"])) {//TODO ASK QA TEAM IF IS THIS OK
    if(isLogged)
    return <Redirect to="/404" />
  }

  if(matchesPath("/shop/tutorials")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesAnyPath(["/shop/tutorial"])) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/client/mycompany")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/client/users")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/client/profile")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/alerts")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/excelimport")) {
    if(!isLogged)
    return <Redirect to="/login" />
  }

  if(matchesPath("/shop/signup")) {
    if(isLogged)
    return <Redirect to="/404" />
  }

  if(matchesPath("/shop/signin")) {
    if(isLogged)
      return <Redirect to="/shop/dashboard" />
  }

  if(path === "/login") {
    if(isLogged)
      return <Redirect to="/shop/dashboard" />
  }

  return props.children
}

export default AuthGuard
